import { TablePill, Text } from '@oy/uidesktop';
import { CardIcon, CardIconName } from '@oy/uiicon';
import { useTranslate } from 'src/hooks';
import { ScheduleMaintenance, TimeMaintenanceAdhoc } from 'src/models';
import { generateDateAdhoc, generateDescriptionMaintenance } from 'src/pages/Disbursement/helper';
import styles from './CardMaintenance.module.css';

type CardMaintenanceProps = {
  type: 'DAILY' | 'ADHOC'
  icon?: string;
  bankName?: string;
  schedules?: ScheduleMaintenance[];
  times?: TimeMaintenanceAdhoc[];
  isMaintenance: boolean;
};

export const CardMaintenance = ({
  type,
  icon,
  bankName,
  schedules = [],
  times = [],
  isMaintenance,
} : CardMaintenanceProps) => {
  const { getTranslation } = useTranslate();
  return (
      <div
        className={styles.card}
      >
        <div className={styles.detail}>
          <div className={styles.icon}>
            <div>
              <CardIcon
                name={icon as CardIconName}
              />
            </div>
            <Text textStyle={Text.Style.BodyLgSemibold}>
              {bankName}
            </Text>
          </div>
          <div
            className={styles.status}
          >
            {
              isMaintenance && (
                <TablePill
                  color={TablePill.Color.Yellow}
                >
                  <i>{getTranslation('common_status_underMaintenance')}</i>
                </TablePill>
              )
            }
          </div>
        </div>
        <div className={styles.listMaintenance}>
          <Text textStyle={Text.Style.BodyMdRegular}>
            {
              type === 'DAILY' ? <ul>
                {
                  schedules?.map((item, index) => (
                    <li key={index}>
                      {item.times.map((time, index) => {
                        if (index > 0) {
                          return (
                            <>
                              {` ${getTranslation('common_and')} `}
                              <b key={`item-daily-${index}`}>
                                {time.start} - {time.end} WIB
                              </b>
                            </>
                          );
                        }
                        return (
                          <b key={index}>
                            {time.start} - {time.end} WIB
                          </b>
                        );
                      })}
                      {` ${generateDescriptionMaintenance(item.days_of_week)}`}
                    </li>
                  ))
                }
              </ul> : <ul>
                {
                  times?.map((item, index) => (
                    <div className={styles.list}>
                      <li key={index} className={styles.listItem}>
                        <span className={styles.label}>{getTranslation('common_startFrom')}</span>
                        <span className={styles.colon}>{' : '}</span>
                        <span className={styles.value}>
                          <b>{generateDateAdhoc(item.date_time_start)}</b>
                        </span>
                      </li>
                      <li key={index} className={styles.listItem}>
                        <span className={styles.label}>{getTranslation('common_endOn')}</span>
                        <span className={styles.colon}>{' : '}</span>
                        <span className={styles.value}>
                          <b>{generateDateAdhoc(item.date_time_end)}</b>
                        </span>
                      </li>
                      {
                        index !== times.length - 1 && <br />
                      }
                    </div>
                  ))
                }
              </ul>
            }
          </Text>
        </div>
      </div>
  );
}
